import { AxiosError } from "axios";

type RequestError = Error | AxiosError

export const instanceOfAxiosError = (object: any): object is AxiosError => {
    return 'response' in object &&
            'data' in object.response &&
            'error' in object.response.data &&
            'message' in object.response.error
}

export default RequestError